import React, { useEffect, useState } from 'react'
import './mediaHub.css'
import { motion } from 'framer-motion';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';


export default function MediaHub() {

    const [mediaHubToggle, setMediaHubToggle] = useState(false);
    const [fullName, setFullName] = useState('');
    const [phoneNum, setPhoneNum] = useState('');
    const [emailID, setEmailID] = useState('');
    const [messageBox, setMessageBox] = useState('');
    const [mhub, setMhub] = useState('');
    const [counter, setCounter] = useState(0)

    useEffect(() => {
        setMhub(document.getElementById('mediaHub'));
        setCounter(1)

    }, [])


    useEffect(() => {

        const mediaHubContent = document.querySelector('.media-hub-content');
        const mediaHub = document.getElementById('mediaHub');

        if (mediaHubToggle) {
            setCounter(2);
            mhub.classList = 'media-hub';
            mediaHubContent.style.transform = 'translateX(0px)';
            mediaHub.style.backgroundColor = '#de4e4e';

        } else {
            mediaHubContent.style.transform = 'translateX(180vw)';
            mediaHub.style.backgroundColor = 'gray';
        }

    }, [mediaHubToggle])


    useEffect(() => {
        if (mhub && counter === 1) {
            setTimeout(() => {
                mhub.classList = 'media-hub media-call'
            }, 20000);
        }
    }, [mhub, counter])


    return (
        <>
            <div className="media-hub-content">
                <h2>Contact Me</h2>

                <form name='contact' method="POST" data-netlify="true">
                    <input type="hidden" name="form-name" value="contact" />
                    <TextField className='custom-field' value={fullName} onChange={e => { setFullName(e.target.value) }} size='small' fullWidth margin="dense" label="Full Name" name='name' required autoComplete="off" />
                    <TextField className='custom-field' value={phoneNum} onChange={e => { setPhoneNum(e.target.value) }} size='small' type='number' fullWidth margin="dense" label="Phone" name='phone' required autoComplete="off" />
                    <TextField className='custom-field' value={emailID} onChange={e => { setEmailID(e.target.value) }} size='small' type='email' fullWidth margin="dense" label="E-Mail" name='email' required autoComplete="off" />
                    <TextField className='custom-field' value={messageBox} onChange={e => { setMessageBox(e.target.value) }} size='small' minRows={6} multiline type='text' fullWidth margin="dense" label="Message" name='message' required autoComplete="off" />
                    <div className="connection-wraper">
                        <Button className='submit-btn' variant='contained' type='submit'>Submit</Button>
                        <div className="social-media">
                            <a rel="noreferrer" href='https://www.instagram.com/urstrulysatyam_/' target='_blank'><span className="insta"></span></a>
                            <a rel="noreferrer" href='https://www.linkedin.com/in/satyamnagar/' target='_blank'><span className="linkedIn"></span></a>
                            <a rel="noreferrer" href='https://github.com/SatyamNagar/' target='_blank'><span className="github"></span></a>
                        </div>
                    </div>
                </form>
            </div>

            <div className='media-hub-container'>
                <Tooltip title='Contact' placement='left'>
                    <motion.div onClick={() => { mediaHubToggle ? setMediaHubToggle(false) : setMediaHubToggle(true) }} drag='y' dragConstraints={{ left: 0, right: 0, top: -150, bottom: 150 }} id='mediaHub' className="media-hub"></motion.div>
                </Tooltip>
            </div>
        </>
    )
}
